module.exports = __webpack_public_path__ + "static/img/DeluxeQueenStudio2.3bad1072.jpg";